import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '@common/app/app.config';
import {AuctionServiceBase} from "@common/services/auction-base.service";
import {SpjpAuction} from "../model/auction";
import {Registration} from "@spjp/model/registration";
import {map, tap} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class SpjpAuctionService extends AuctionServiceBase<SpjpAuction> {
    url: string;
    constructor(
        protected override http: HttpClient,
        @Inject(API_URL) protected override baseUrl: string,
    ) {
        super(http, baseUrl);
    }

    getStripeProductId$(registration : Registration): Observable<string> {
        return this.getByCode$(registration.auction.code).pipe(map(a => a.stripeProductId));

    }
}
